import { ZoningStatus } from '@lidea/shared/util/types';
import { useTranslation } from 'react-i18next';

import styles from './yield-status-badge.module.css';

type StatusConfig = {
  className: string;
  labelKey: 'yield_status_ready' | 'yield_status_in_progress' | 'yield_status_todo';
};

const STATUS_CONFIG: Record<ZoningStatus, StatusConfig> = {
  [ZoningStatus.Ready]: {
    className: styles.ready,
    labelKey: 'yield_status_ready',
  },
  [ZoningStatus.InProgress]: {
    className: styles.inProgress,
    labelKey: 'yield_status_in_progress',
  },
  [ZoningStatus.ToBeDone]: {
    className: styles.todo,
    labelKey: 'yield_status_todo',
  },
};

export interface YieldStatusBadgeProps {
  status: ZoningStatus;
}

export function YieldStatusBadge({ status }: YieldStatusBadgeProps) {
  const { t } = useTranslation(['plot'], { useSuspense: false });
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG[ZoningStatus.ToBeDone];

  return (
    <span className={`${styles.badge} ${config.className}`}>
      <span aria-hidden className={styles.dot} />
      {t(`plot:${config.labelKey}`)}
    </span>
  );
}

export default YieldStatusBadge;
